import ICommand from '../../../FrontApplet/Command/ICommand';
import { ITypedCommandEvent } from '../../../FrontApplet/Command/ICommandEvent';
import FrontApplet from '../../../FrontApplet/FrontApplet';
import {
	ManagementNetworkDisableInterfaceRequest,
	ManagementNetworkDisableInterfaceResult,
	ManagementNetworkListInterfacesRequest,
	ManagementNetworkListInterfacesResult,
	ManagementNetworkRequests,
	ManagementNetworkSendUdpRequest,
	ManagementNetworkSendUdpResult,
	ManagementNetworkSendWakeOnLanRequest,
	ManagementNetworkSendWakeOnLanResult,
	ManagementNetworkSetDHCPServerRequest,
	ManagementNetworkSetDHCPServerResult,
	ManagementNetworkSetManualRequest,
	ManagementNetworkSetManualResult,
} from './managementNetworkCommands';

export function handleManagementNetworkRequests(
	onCommand: (callback: (commandEvent: ITypedCommandEvent<ManagementNetworkRequests>) => Promise<void>) => void,
	dispatch: <TCommand extends ICommand>(command: TCommand) => Promise<void>,
	frontApplet: FrontApplet,
) {
	onCommand(async (commandEvent: ITypedCommandEvent<ManagementNetworkRequests>) => {
		switch (commandEvent.command.type) {
			case ManagementNetworkListInterfacesRequest:
				await dispatch<ManagementNetworkListInterfacesResult>({
					type: ManagementNetworkListInterfacesResult,
					result: await frontApplet.management.network.listInterfaces(),
				});
				break;
			case ManagementNetworkSetManualRequest:
				await frontApplet.management.network.setManual(commandEvent.command.interfaceName, commandEvent.command.options);
				await dispatch<ManagementNetworkSetManualResult>({
					type: ManagementNetworkSetManualResult,
					result: {},
				});
				break;
			case ManagementNetworkSetDHCPServerRequest:
				await frontApplet.management.network.setDHCP(commandEvent.command.interfaceName);
				await dispatch<ManagementNetworkSetDHCPServerResult>({
					type: ManagementNetworkSetDHCPServerResult,
					result: {},
				});
				break;
			case ManagementNetworkDisableInterfaceRequest:
				await frontApplet.management.network.disableInterface(commandEvent.command.interfaceName);
				await dispatch<ManagementNetworkDisableInterfaceResult>({
					type: ManagementNetworkDisableInterfaceResult,
					result: {},
				});
				break;
			case ManagementNetworkSendUdpRequest:
				await frontApplet.management.network.sendUdp(commandEvent.command.ip, commandEvent.command.port, commandEvent.command.data);
				await dispatch<ManagementNetworkSendUdpResult>({
					type: ManagementNetworkSendUdpResult,
					result: {},
				});
				break;
			case ManagementNetworkSendWakeOnLanRequest:
				await frontApplet.management.network.sendWakeOnLan(commandEvent.command.macAddress);
				await dispatch<ManagementNetworkSendWakeOnLanResult>({
					type: ManagementNetworkSendWakeOnLanResult,
					result: {},
				});
				break;
			default:
		}
	});
}
